export default __webpack_public_path__ + "static/media/mobileHero.13e07f73.jpg";